import { useEffect, useState } from 'react';
import Image from 'next/image';
export const ImageWithFallback = ({
  fallback = '/static/geniusImages/network_logos/baseFallbackToken.png',
  alt,
  src,
  width = 100,
  height = 100,
  ...props
}: {
  fallback?: string;
  alt: string;
  src: string;
  width?: number;
  height?: number;
  [key: string]: any;
}) => {
  const [imgSrc, setImgSrc] = useState(null);
  const [isError, setIsError] = useState(false);
  useEffect(() => {
    if (src) {
      setImgSrc(src?.startsWith('http://') || src?.startsWith('https://') ? `/api/proxy-image?url=${encodeURIComponent(src)}` : src);
      setIsError(false);
    } else {
      setIsError(true);
    }
  }, [src]);
  const handleError = e => {
    setIsError(true);
  };
  return <>
      {imgSrc && <Image alt={alt} src={isError ? fallback : imgSrc} width={width} height={height} onError={handleError} {...props} />}
    </>;
};